/*global _, moment, swal angular*/
export default function() {
  return ($scope, $uibModalInstance) => {
    'ngInject';
    $scope.nasbaExample = 'https://assets.prolaera.com/exampleCert.png';
    $scope.close = () => $uibModalInstance.dismiss('cancel');
  };
}



// WEBPACK FOOTER //
// ./src/app/modals/certificateSponsorInfo/index.js